import React,{ createContext } from 'react'

const isEditStateContext = createContext(false)
const isSaveContext = createContext(false)
const isDeleteContext = createContext(false)

export  {
  isEditStateContext,
  isSaveContext,
  isDeleteContext
}
